export default __webpack_public_path__ + "static/media/Messages.84653a76.svg";